/* Rollin'Denims site layer v1 */
(function () {
  'use strict';
  function slug(t) { return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60); }

  function toc(root) {
    var nav = root.querySelector('[data-rdp-toc]');
    var rte = root.querySelector('[data-rdp-rte]');
    if (!nav || !rte) return;
    var hs = rte.querySelectorAll('h2');
    if (hs.length < 2) { nav.remove(); var g = root.querySelector('.rdp-grid'); if (g) g.classList.remove('has-toc'); return; }
    var links = [];
    hs.forEach(function (h) {
      if (!h.id) h.id = slug(h.textContent);
      var a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent;
      nav.appendChild(a); links.push([h, a]);
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) links.forEach(function (p) { p[1].classList.toggle('is-on', p[0] === e.target); });
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    links.forEach(function (p) { io.observe(p[0]); });
  }

  function faqify(root) {
    var rte = root.querySelector('[data-rdp-faqify]');
    if (!rte) return;
    var hs = Array.prototype.slice.call(rte.querySelectorAll(':scope > h3'));
    hs.forEach(function (h) {
      var d = document.createElement('details');
      var sm = document.createElement('summary');
      sm.innerHTML = h.innerHTML;
      var body = document.createElement('div');
      body.className = 'rd-acc__body';
      var n = h.nextElementSibling;
      while (n && !/^H[23]$/.test(n.tagName)) { var nx = n.nextElementSibling; body.appendChild(n); n = nx; }
      d.appendChild(sm); d.appendChild(body);
      h.parentNode.replaceChild(d, h);
    });
    // group consecutive details into accordions
    var kids = Array.prototype.slice.call(rte.children), grp = null;
    kids.forEach(function (k) {
      if (k.tagName === 'DETAILS') {
        if (!grp) { grp = document.createElement('div'); grp.className = 'rd-acc'; k.parentNode.insertBefore(grp, k); }
        grp.appendChild(k);
      } else grp = null;
    });
  }


  /* ---------- Form delivery: Shopify (admin@) + confirmation to customer + copy to team ---------- */
  function cfg() { var c = window.RD_MAIL || {}; return (c.key && c.service && c.tpl_customer) ? c : null; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function makeRef() {
    var d = new Date(), p = function (n) { return ('0' + n).slice(-2); };
    var r = Math.random().toString(36).slice(2, 6).toUpperCase();
    return 'RD-' + String(d.getFullYear()).slice(2) + p(d.getMonth() + 1) + p(d.getDate()) + '-' + r;
  }
  function collect(f) {
    var rows = [];
    f.querySelectorAll('[data-rdp-label]').forEach(function (el) {
      var v = el.type === 'checkbox' ? (el.checked ? 'Yes' : '') : (el.value || '').trim();
      if (v) rows.push([el.getAttribute('data-rdp-label'), v]);
    });
    return rows;
  }
  function send(c, tpl, params) {
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, 8000);
    return fetch('https://api.emailjs.com/api/v1.0/email/send', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctl ? ctl.signal : undefined,
      body: JSON.stringify({ service_id: c.service, template_id: tpl, user_id: c.key, template_params: params })
    }).then(function (r) { clearTimeout(t); return r.ok; }).catch(function () { clearTimeout(t); return false; });
  }
  function rdSubmit(f, e) {
    if (f.__rdGo) return;
    e.preventDefault();
    var hp = f.querySelector('[name="rd_hp"]');
    var b = f.querySelector('button[type="submit"]');
    if (b) { b.disabled = true; b.textContent = 'Sending…'; }
    var ref = makeRef();
    var refIn = f.querySelector('[data-rdp-ref-input]'); if (refIn) refIn.value = ref;
    var emailEl = f.querySelector('[name="contact[email]"]');
    var nameEl = f.querySelector('[name="contact[name]"]');
    var email = emailEl ? emailEl.value.trim() : '';
    var name = nameEl ? nameEl.value.trim().split(' ')[0] : '';
    var formName = f.getAttribute('data-rdp-name') || document.title;
    var go = function (sent) {
      try { sessionStorage.setItem('rdForm', JSON.stringify({ ref: ref, email: email, sent: !!sent, form: formName })); } catch (x) {}
      f.__rdGo = true;
      HTMLFormElement.prototype.submit.call(f);
    };
    var c = cfg();
    if (!c || !email || (hp && hp.value)) return go(false);
    var rows = collect(f);
    var html = '<table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse">' + rows.map(function (r) {
      return '<tr><td style="padding:10px 12px;border-bottom:1px solid #e6e6e8;font:600 13px Montserrat,Arial,sans-serif;color:#6f7178;width:38%;vertical-align:top">' + esc(r[0]) + '</td><td style="padding:10px 12px;border-bottom:1px solid #e6e6e8;font:400 14px Ubuntu,Arial,sans-serif;color:#0d0d0d">' + esc(r[1]).replace(/\n/g, '<br>') + '</td></tr>';
    }).join('') + '</table>';
    var text = rows.map(function (r) { return r[0] + ': ' + r[1]; }).join('\n');
    var params = {
      form_name: formName, reference: ref, to_email: email, to_name: name || 'there', reply_to: email,
      fields_html: html, fields_text: text, next_steps: f.getAttribute('data-rdp-next') || '',
      page_url: location.href.split('?')[0], wa_number: '+91 81690 97713', wa_link: 'https://wa.me/918169097713'
    };
    var jobs = [send(c, c.tpl_customer, params)];
    if (c.tpl_team) jobs.push(send(c, c.tpl_team, params));
    Promise.all(jobs).then(function (r) { go(r[0]); });
  }
  function okState() {
    var ok = document.querySelector('[data-rdp-ok]');
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem('rdForm') || 'null'); sessionStorage.removeItem('rdForm'); } catch (x) {}
    if (!ok) return;
    if (data) {
      var r = ok.querySelector('[data-rdp-ref]');
      if (r) { r.innerHTML = 'Reference <b>' + esc(data.ref) + '</b>' + (data.sent && data.email ? '. A copy is on its way to <b>' + esc(data.email) + '</b>.' : '. Keep it handy if you message us.'); r.hidden = false; }
    }
    try { ok.scrollIntoView({ block: 'center' }); } catch (x) {}
  }

  function waForms(root) {
    root.querySelectorAll('[data-rdp-wa]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.closest('form');
        var lines = [btn.getAttribute('data-rdp-wa-title') || 'Request'];
        form.querySelectorAll('[data-rdp-label]').forEach(function (el) {
          var v = el.type === 'checkbox' ? (el.checked ? 'Yes' : '') : (el.value || '').trim();
          if (v) lines.push(el.getAttribute('data-rdp-label') + ': ' + v);
        });
        var url = 'https://wa.me/' + btn.getAttribute('data-rdp-wa') + '?text=' + encodeURIComponent(lines.join('\n'));
        window.open(url, '_blank', 'noopener');
      });
    });
    root.querySelectorAll('[data-rdp-form]').forEach(function (f) {
      f.addEventListener('submit', function (e) { rdSubmit(f, e); });
    });
    // Prefill from ?order=…&product=…
    try {
      var q = new URLSearchParams(location.search);
      root.querySelectorAll('[data-rdp-label]').forEach(function (el) {
        var l = el.getAttribute('data-rdp-label').toLowerCase();
        if (q.get('order') && l.indexOf('order') > -1 && !el.value) el.value = q.get('order');
        if (q.get('product') && l.indexOf('product') > -1 && el.tagName === 'SELECT') {
          Array.prototype.forEach.call(el.options, function (o) { if (o.text.toLowerCase().indexOf(q.get('product').toLowerCase()) > -1) el.value = o.value; });
        }
      });
    } catch (e) {}
  }

  function news() {
    var f = document.querySelector('[data-rdf-news]');
    if (!f) return;
    if (/customer_posted=true/.test(location.search)) {
      var m = f.parentNode.querySelector('.rdf__msg'); if (m) m.hidden = false;
    }
    f.addEventListener('submit', function (e) {
      if (f.__rdGo) return;
      var c = cfg(), em = f.querySelector('[name="contact[email]"]');
      if (!c || !c.tpl_news || !em || !em.value) return;
      e.preventDefault();
      var b = f.querySelector('button'); if (b) { b.disabled = true; b.textContent = '…'; }
      send(c, c.tpl_news, { to_email: em.value.trim(), reply_to: 'hello@rollindenims.com' }).then(function () { f.__rdGo = true; HTMLFormElement.prototype.submit.call(f); });
    });
  }

  /* ---------- Intent signals: every WhatsApp / call / email tap is a Contact event ---------- */
  function intent() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var h = a.getAttribute('href') || '', ch = /wa\.me|whatsapp/i.test(h) ? 'whatsapp' : /^tel:/i.test(h) ? 'call' : /^mailto:/i.test(h) ? 'email' : '';
      if (!ch) return;
      var where = location.pathname;
      try { if (window.fbq) window.fbq('track', 'Contact', { content_category: ch, content_name: where }); } catch (x) {}
      try { if (window.gtag) window.gtag('event', 'contact', { method: ch, page_path: where }); } catch (x) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'rd_contact', channel: ch, page: where }); } catch (x) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('rd_contact', { channel: ch, page: where }); } catch (x) {}
    }, true);
  }

  function init() {
    document.querySelectorAll('[data-rdp]').forEach(function (r) { faqify(r); toc(r); waForms(r); });
    news();
    okState();
    intent();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
